// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3iiUo","header":"MergedInvoice_header__HDYp6"};